import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JobQuestion } from '../../apply-layout/apply-layout.component';

@Component({
  selector: 'app-job-questions',
  templateUrl: './job-questions.component.html',
  styleUrls: ['./job-questions.component.css'],
})
export class JobQuestionsComponent implements OnInit {
  @Input() questions: JobQuestion[] = [];

  @Output() next = new EventEmitter<{ questionId: string; question: string; answer: string }[]>();
  @Output() cancel = new EventEmitter<void>();

  questionsForm!: FormGroup;

  get sortedQuestions(): JobQuestion[] {
    return [...this.questions].sort((a, b) => a.displayOrder - b.displayOrder);
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    const controls: Record<string, any> = {};
    this.sortedQuestions.forEach((q, i) => {
      controls[`question_${i}`] = [
        '',
        q.required ? [Validators.required, Validators.minLength(2)] : [],
      ];
    });
    this.questionsForm = this.fb.group(controls);
  }

  controlKey(index: number): string {
    return `question_${index}`;
  }

  isInvalid(index: number): boolean {
    const ctrl = this.questionsForm.get(this.controlKey(index));
    return !!(ctrl?.invalid && ctrl?.touched);
  }

  onNext(): void {
    if (this.questionsForm.valid) {
      const answers = this.sortedQuestions.map((q, i) => ({
        questionId: q.questionId,   // ✅ غيرنا من q.id لـ q.questionId
        question:   q.question,
        answer:     this.questionsForm.get(this.controlKey(i))?.value ?? ''
      }));
      this.next.emit(answers);
    } else {
      this.questionsForm.markAllAsTouched();
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}